export default __webpack_public_path__ + "static/media/cart-05-EN.58f795e2.jpg";